module.exports = __webpack_public_path__ + "static/img/img34.80704b8d.png";